import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../constants.js";
export const addDataFactoryIdToCustomer = (customer, dataFactoryId) => {
    if (!dataFactoryId) {
        return customer;
    }
    return {
        ...customer,
        externalReferences: [
            ...(customer.externalReferences ?? []),
            {
                key: CUSTOMER_EXTERNAL_REFERENCE_KEY.DATA_FACTORY_ID,
                value: dataFactoryId.toString(),
            },
        ],
    };
};
